<template>
    <div class="position-fixed bottom-0 right-0 p-3" style="z-index: 1550; right: 0; bottom: 0;">
        <div v-for="(notify, index) of notifications" :key="notify.id" ref="liveToast" class="toast hide" role="alert"
             aria-live="assertive" aria-atomic="true">
            <div class="toast-header">
                <svg class="bd-placeholder-img rounded mr-2" width="20" height="20"
                     xmlns="http://www.w3.org/2000/svg" role="img" aria-label=" :  "
                     preserveAspectRatio="xMidYMid slice" focusable="false"><title></title>
                    <rect width="100%" height="100%" fill="#007aff"></rect>
                    <text x="50%" y="50%" fill="#dee2e6" dy=".3em"></text>
                </svg>
                <!-- <img src="..." class="rounded mr-2" alt="..."> -->
                <strong class="mr-auto">{{ notify.title || 'Playground' }}</strong>
                <small>{{ notify.info }}</small>
                <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="toast-body" :class="notify.options.class ? `alert-${notify.options.class}` : ''">
                {{ notify.message }}
            </div>
        </div>
    </div>
</template>
<script>
import {notifyEvent} from "../../library/notifications";

export default {
    data() {
        return {
            notifications: []
        };
    },
    mounted() {
        console.log('mounted');
        notifyEvent.$on('add', (notify) => {
            const newID = () => {
                let counter = 1;
                while (this.notifications.filter(item => item.id === counter).length) {
                    counter++;
                }
                return counter;
            }
            let myId = newID(), options,
                {animation = true, autohide = true, delay = 3000} = notify.options;
            options = {
                animation: !!animation,
                autohide: !!autohide,
                class: notify.options.class ?? '',
                delay: Number(delay)
            };
            notify.id = myId;
            length = this.notifications.push(notify);
            this.$nextTick(() => {
                let toasts = this.$refs.liveToast,
                    myIndex = this.notifications.findIndex(item => myId === item.id),
                    showTime = Date.now(), hideTime;
                $(toasts[myIndex]).toast(options);
                $(toasts[myIndex]).toast('show');
                $(toasts[myIndex]).on('hidden.bs.toast', (...args) => {
                    hideTime = Date.now();
                    // console.log({myIndex, myId, args, through: hideTime - showTime});
                    let myIndex = this.notifications.findIndex(item => myId === item.id);
                    this.notifications.splice(myIndex, 1);
                    // console.log(toasts, this.notifications.map(item => item.id));
                });
                // console.log(toasts, this.notifications);
            });
        });
    }
}
</script>
